import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

export default function Contacts() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);
  const email = "info@otra-m.ru";
  const subject = encodeURIComponent("Вопрос по нашему проекту");
  const body = encodeURIComponent("Здравствуйте, я хотел бы уточнить ...");

  // ИСПРАВЛЕННЫЙ ЭФФЕКТ: ловит событие от компонента Pricing
  useEffect(() => {
    const handleServiceSelect = (event) => {
      const serviceName = event.detail;
      
      if (serviceName) {
        // Записываем текст в стейт React, чтобы он не терялся
        setFormData((prev) => ({
          ...prev,
          message: `Интересует услуга: ${serviceName}`
        }));
        
        // Переводим фокус на поле Сообщение
        const textarea = document.querySelector("#contacts textarea");
        if (textarea) {
          textarea.focus();
        }
      }
    };

    // Включаем прослушивание кликов
    window.addEventListener("selectService", handleServiceSelect);
    
    // Выключаем при уходе со страницы
    return () => {
      window.removeEventListener("selectService", handleServiceSelect);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "info", msg: "Отправка..." });

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus({ type: "success", msg: "Заявка успешно отправлена!" });
        setFormData({ name: "", email: "", message: "" });
      } else {
        throw new Error();
      }
    } catch (err) {
      setStatus({ type: "error", msg: "Ошибка. Попробуйте позже." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contacts" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* ЛЕВАЯ КОЛОНКА: Контакты и Форма */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-12"
          >
            <div>
              <h2 className="text-4xl font-black text-slate-900 mb-6 uppercase tracking-tighter italic">
                Контакты
              </h2>
              <p className="text-lg text-slate-500 max-w-md leading-relaxed">
                Обсудим Ваш проект по ИБ, автоматизации или техподдержке?
                Наши эксперты на связи!
              </p>
            </div>

            {/* Форма обратной связи */}
            <form
              onSubmit={handleSubmit}
              className="bg-slate-50 p-8 rounded-[2.5rem] border border-slate-100 shadow-sm space-y-5"
            >
              <div className="space-y-2">
                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-2">
                  Имя
                </label>
                <input
                  required
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  className="w-full bg-white border border-slate-200 rounded-2xl px-5 py-4 outline-none focus:ring-2 ring-blue-500 transition-all text-sm"
                  placeholder="Иван Иванов"
                />
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-2">
                  Email
                </label>
                <input
                  required
                  type="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  className="w-full bg-white border border-slate-200 rounded-2xl px-5 py-4 outline-none focus:ring-2 ring-blue-500 transition-all text-sm"
                  placeholder="office@otra-m.ru"
                />
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-2">
                  Сообщение
                </label>
                <textarea
                  required
                  rows="4"
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({ ...formData, message: e.target.value })
                  }
                  className="w-full bg-white border border-slate-200 rounded-2xl px-5 py-4 outline-none focus:ring-2 ring-blue-500 transition-all text-sm resize-none"
                  placeholder="Опишите вашу задачу..."
                ></textarea>
              </div>

              <button
                disabled={loading}
                className="w-full bg-blue-600 text-white font-bold py-5 rounded-2xl hover:bg-blue-700 shadow-lg shadow-blue-100 transition-all active:scale-95 disabled:bg-slate-300"
              >
                {loading ? "ОТПРАВКА..." : "ОТПРАВИТЬ ЗАЯВКУ"}
              </button>

              {status.msg && (
                <p
                  className={`text-center text-xs font-bold uppercase tracking-wider mt-4 ${
                    status.type === "success"
                      ? "text-green-600"
                      : "text-red-500"
                  }`}
                >
                  {status.msg}
                </p>
              )}
            </form>

            {/* Юридический блок */}
            <div className="pt-8 border-t border-slate-100 grid sm:grid-cols-2 gap-8">
              <div className="space-y-2">
                <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">
                  Реквизиты
                </p>
                <p className="text-xs text-slate-500 leading-relaxed italic">
                  ООО "ОТРА-М" <br /> ИНН 7702839551 <br />
                  Аккредитация Минцифры №68290 <br />
                  Юр. адрес: 109462, г.Москва, вн.тер.г. Муниципальный Округ Кузьминки, б-р Волжский, д. 51, стр. 8 <br />
                  <a href={`mailto:${email}?subject=${subject}&body=${body}`}>
                    <span className="text-blue-600 underline">info@otra-m.ru</span>
                  </a>
                </p>
              </div>
              <div className="space-y-2">
                <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">
                  Телефон
                </p>
                <p className="text-sm font-bold text-slate-800 underline">
                  <a href="tel:+74994954963">+7 (499) 495-49-63</a>
                </p>
              </div>
            </div>
          </motion.div>

          {/* ПРАВАЯ КОЛОНКА: Карта */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative h-full min-h-[600px] rounded-[3rem] overflow-hidden shadow-2xl border border-slate-100 group w-full"
          >
            <iframe
              src="https://yandex.ru/map-widget/v1/?um=constructor%3A0f8f80dd8b71dd60b651c76d23951137587e0c03b37a5c9b198d883145b1c966&amp;source=constructor"
              frameBorder="0"
              allowFullScreen={true}
              className="absolute inset-0 w-full h-full grayscale contrast-125 group-hover:grayscale-0 transition-all duration-1000 ease-in-out scale-110 group-hover:scale-100"
              title="Yandex Map"
            ></iframe>

            {/* Парящий блок адреса */}
            <div className="absolute bottom-8 left-8 right-8 bg-white/80 backdrop-blur-xl p-8 rounded-[2rem] shadow-xl border border-white/20 pointer-events-none">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center text-white font-bold italic">
                  ИТ
                </div>
                <div>
                  <p className="text-[10px] font-black text-blue-600 uppercase tracking-widest">
                    Главный офис
                  </p>
                </div>
              </div>
              <p className="text-sm text-slate-600 leading-relaxed font-medium">
                109462, г. Москва, вн.тер.г. Муниципальный Округ Кузьминки, б-р
                Волжский, д. 51, стр. 8
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
